export default "__VITE_ASSET__255cc460__"